import Image from '@/components/Image';
import React from 'react';

export const renderTextWithKlarnaLogo = (text: string, child: React.ReactNode) => {
  return text.split('Klarna').map((part, index, arr) => {
    const partWithoutTrailingSpace = index < arr.length - 1 ? part.replace(/\s+$/, '') : part;

    return (
      <React.Fragment key={index}>
        {partWithoutTrailingSpace}
        {index < arr.length - 1 && (
          <span className="inline-flex items-center align-middle whitespace-nowrap px-1 mr-[4px]">
            {child}
          </span>
        )}
      </React.Fragment>
    );
  });
};

export interface ColorHighlight {
  match: string | RegExp;
  color: string;
}

interface KlarnaPromotionTextOptions {
  isWAP?: boolean;
}

/** 将 string | RegExp 统一转为 regex source，string 会自动转义特殊字符 */
function toSource(m: string | RegExp): string {
  return typeof m === 'string' ? m.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : m.source;
}

/**
 * 渲染 Klarna 促销文本：
 * - `Klarna` → KlarnaLogo 图标
 * - highlights 中每条规则匹配的片段 → 对应颜色
 *
 * @example
 * renderKlarnaPromotionText(text, [
 *   { match: '$15 off', color: '#E02020' },
 *   { match: /\$\d+\+?/, color: '#E02020' },
 * ])
 */
export function renderKlarnaPromotionText(
  text: string,
  highlights: ColorHighlight[] = [],
  options: KlarnaPromotionTextOptions = {},
) {
  const { isWAP = false } = options;
  const allPatterns = ['Klarna', ...highlights.map((h) => toSource(h.match))];
  const splitRegex = new RegExp(`(${allPatterns.join('|')})`);

  return text.split(splitRegex).map((part, index) => {
    if (part === 'Klarna') {
      return (
        <Image
          key={index}
          src="/goods-detail/klarna.png"
          alt="klarna payment"
          width={isWAP ? 58 : 50}
          height={isWAP ? 16 : 12}
          style={
            isWAP
              ? undefined
              : {
                  height: 'max(.8333333333vw, 12px)',
                }
          }
          className={
            isWAP
              ? 'inline-block w-auto h-[16px] align-middle mx-[4px]'
              : 'inline w-auto align-middle ml-1 mx-[4px]'
          }
        />
      );
    }

    const hit = highlights.find((h) =>
      typeof h.match === 'string' ? h.match === part : h.match.test(part),
    );
    if (hit) {
      return (
        <span key={index} style={{ color: hit.color }}>
          {part}
        </span>
      );
    }
    return <React.Fragment key={index}>{part}</React.Fragment>;
  });
}
